module.exports = __webpack_public_path__ + "img/hr-stack-inserter-hand-open.3647c73e.png";